export const plans = [
        { code: "FREE", title: "베이직 스타터", price: "0원" },
        { code: "LIFE", title: "라이프 서포트", price: "20,000원" },
        { code: "MASTER", title: "마스터 클래스", price: "60,000원" },
        { code: "EXPERT", title: "엑스퍼트 어드바이저", price: "100,000원" }
    ];

export const TARGET_WIDTH = 212;
export const TARGET_HEIGHT = 159;